import React from 'react';
import { useLocation } from 'react-router-dom';
import AccessibilityTools from './AccessibilityTools';
import AgeGate from './AgeGate';
import LearningPlatformRouter from './LearningPlatformRouter';
import ProgrammeCoursePlayer from './ProgrammeCoursePlayer';

const ACCOUNT_SERVICES_URL = 'https://my.sousamurray.co.uk/account/services';
const PUBLIC_ELEARNING_URL = 'https://sousamurray.co.uk/elearning';

function ExternalRedirect({ to }: { to: string }) {
  React.useEffect(() => {
    window.location.replace(to);
  }, [to]);
  return <main style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', fontFamily: 'system-ui, sans-serif' }}><p>Returning to Sousa Murray…</p></main>;
}

export default function RootApplication() {
  const path = useLocation().pathname;
  const course = path.match(/^\/lms\/course\/([^/]+)$/);

  // The service root is no longer a public website or sign-in point.
  if (path === '/') return <ExternalRedirect to={ACCOUNT_SERVICES_URL} />;

  // The public catalogue remains centralised, but the governed mixed course
  // basket is a purchase hand-off route from the main Sousa Murray storefront.
  if (path === '/basket' || path === '/learning-library/basket') return <LearningPlatformRouter />;

  // Purchasing and subscription selection now belong to the central Sousa Murray shop.
  if (path.startsWith('/lms/subscribe/')) return <ExternalRedirect to={`${PUBLIC_ELEARNING_URL}/plans`} />;

  // Genuine learner platform routes remain on the private service application.
  if (course) {
    return <>
      <AgeGate />
      <AccessibilityTools />
      <ProgrammeCoursePlayer slug={decodeURIComponent(course[1])} />
    </>;
  }
  if (path === '/lms' || path.startsWith('/lms/')) return <LearningPlatformRouter />;

  // All catalogue, plans, pricing, organisation, support and legal browsing is centralised.
  return <ExternalRedirect to={PUBLIC_ELEARNING_URL} />;
}
